module.exports = __webpack_public_path__ + "static/media/PushtimargImage23.7730ab42.jpg";